var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ai Star"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Star 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 3L9.38595 4.65943C8.57567 6.84919 6.84919 8.57567 4.65943 9.38595L3 10L4.65943 10.614C6.84919 11.4243 8.57567 13.1508 9.38595 15.3406L10 17L10.614 15.3406C11.4243 13.1508 13.1508 11.4243 15.3406 10.614L17 10L15.3406 9.38595C13.1508 8.57567 11.4243 6.84919 10.614 4.65943L10 3Z",
    fill: "#0F1E24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 3L9.38595 4.65943C8.57567 6.84919 6.84919 8.57567 4.65943 9.38595L3 10L4.65943 10.614C6.84919 11.4243 8.57567 13.1508 9.38595 15.3406L10 17L10.614 15.3406C11.4243 13.1508 13.1508 11.4243 15.3406 10.614L17 10L15.3406 9.38595C13.1508 8.57567 11.4243 6.84919 10.614 4.65943L10 3Z",
    fill: "url(#paint0_linear_2517_47148)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2517_47148",
    x1: 10,
    y1: 3,
    x2: 10,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31C57D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3B768B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStar);
export default __webpack_public_path__ + "static/media/ai-star.9d5c8df5f87eef4088c8e1ef17304ef0.svg";
export { ForwardRef as ReactComponent };